/**
 * STABILITY-CRITICAL: sessão de limpeza FORA do React. Sobrevive ao desmonte do router (o gate
 * desmonta as páginas antes do reset do banco). Antes de alterar, leia
 * docs/llm/slices/sync-engine.md e alinhe com o responsável pelo sync.
 */
import { createFlowUiController } from './flowUiController'
import type { FlowUiController } from './flowUiController'
import { describeFailure } from './messages'
import { runCleanup } from './performCleanup'

type Session = { controller: FlowUiController } | null
let session: Session = null
let listeners: Array<() => void> = []
const notify = () => listeners.slice().forEach((l) => l())

export const getCleanupSession = (): Session => session
export function subscribeCleanupSession(l: () => void) {
  listeners.push(l)
  return () => {
    listeners = listeners.filter((x) => x !== l)
  }
}

export function startCleanupSession(
  opts: {
    run?: (a: {
      ui: any
      deps: any
    }) => Promise<{ success: boolean; reason?: string; message?: string }>
    createDeps?: () => Promise<any>
  } = {},
): void {
  if (session) return
  const controller = createFlowUiController('limpeza')
  session = { controller }
  notify()
  void (async () => {
    try {
      const createDeps =
        opts.createDeps ??
        (async () => (await import('./defaultDeps')).createCleanupDeps())
      const deps = await createDeps()
      const result = await (opts.run ?? runCleanup)({ ui: controller.ui, deps })
      if (!result.success) {
        controller.actions.fail(
          describeFailure({
            reason: result.reason ?? 'error',
            message: result.message,
          }),
        )
      }
    } catch (e) {
      controller.actions.fail(
        describeFailure({
          reason: 'error',
          message: e instanceof Error ? e.message : String(e),
        }),
      )
    }
  })()
}

export function endCleanupSession(): void {
  session = null
  notify()
}
